/* import __COLOCATED_TEMPLATE__ from './review-info.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './review-info.module.scss';

@classic
@classNames('text-left', styles.component)
export default class RequestInformationReviewInfo extends Component {}
